<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="flavors">
          <div class="row mb-10">
            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
              <div class="content">
                <h1 class="title-landing">¡Hola! Te quiero contar un poco más sobre mi...</h1>
                <p class="description">
                  Soy un helado libre de lácteos y sin azúcares refinados. Estoy hecho con crema de coco y endulzado con miel de agave. No tengo ningún tipo de bases
                  o conservadores. Los ingredientes que me componen fueron perfeccionados por la naturaleza, no la ciencia.
                </p>
                <p class="description">
                  Para poder disfrutarme al máximo, déjame 10 minutos afuera del congelador antes de comerme y así voy a tener la textura perfecta.<br><br>
                  Además, estoy congelado a -25 C° grados para llegar en perfecto estado a tu casa.
                </p>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12 d-flex align-center justify-center">
              <img class="frutas" src="../../assets/home/frutas.png" alt="">
            </div>
          </div>
          <div class="row mb-10">
            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12 d-flex align-center justify-center">
              <img class="helados" src="../../assets/home/helados.png" alt="">
            </div>
            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12 d-flex align-center justify-center">
              <div class="content">
                <p class="description">
                  ¡Somos una heladería que no genera residuos! Por eso el frasco en donde vengo es reutilizable, lo puedes usar para lo que tú quieras en tu casa, o bien, regresarme a Nieve de Olla en donde te harán un descuento cuando vuelvas a comprarme.
                </p>
              </div>
            </div>
          </div>
          <div class="row mb-10">
            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12 d-flex align-items-start justify-content-center">
              <div class="content">
                <p class="description">
                  Me encanta que todos los ingredientes con los que me elaboran provienen de proveedores locales, y así contribuimos a impulsar la economía local y a que todos crezcamos juntos.
                  <br><br>
                  ¿Quieres saber más de tu sabor favorito? ¡Pícale a los siguientes links!
                </p>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12 d-flex align-center justify-center">
              <img class="hojas" src="../../assets/home/hojas.png" alt="">
            </div>
          </div>
          <div class="row">
            <div
              v-for="(item, index) in categories"
              :key="item.id"
              :class="index == 0 ? 'col-lg-7 col-md-7 col-xs-12 col-sm-12' : 'col-lg-5 col-md-5 col-xs-12 col-sm-12'"
            >
              <div class="content">
                <div class="title-with-image">
                  <div class="content-flavor">
                    <img :class="`${index == 0 ? 'img-categoria-sabor2' : 'img-categoria-sabor1'} img-categoria-sabor`" :src="item.url_icon" alt="">
                    <h2 class="title-category" @click="viewDetailCategory(item)">{{ item.name }}</h2>
                  </div>
                </div>
                <div class="row">
                  <div
                    v-for="(chunk, index) in item.flavors_chunk"
                    :key="index"
                    :class="`${item.flavors_chunk.length > 1 ? 'col-lg-6 col-md-8' : 'col-lg-12 col-md-12'} col-sm-12 col-xs-12`"
                  >
                    <div v-for="flavor in chunk" :key="flavor.id" class="title-with-image">
                      <div class="content-flavor">
                        <img class="img-sabor" :src="flavor.url_icon" alt="">
                        <h2 @click="viewDetailFlavor(flavor)">{{ flavor.name }}</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="open_modal_flavor"
      width="1100"
    >
      <v-card v-if="detail">
        <div class="container-detail">
          <div class="row">
            <div class="col d-flex justify-end">
              <v-btn text small @click="() => open_modal_flavor = !open_modal_flavor">
                <v-icon color="#0D3B60">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="content">
                <img class="img-flavor-detail" :src="detail.url_icon" :alt="detail.name">
                <h1 class="title-detail">{{ detail.name }}</h1>
                <p class="description-detail">
                  <b>Ingredientes:</b> {{ detail.ingredients }}
                </p>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="content">
                <h3 class="title-nutrition text-center">INFORMACIÓN NUTRIMENTAL</h3> <br>
                <div v-for="item in detail.detail_flavor" :key="item.id">
                  <div class="content-information-nutrition">
                    <span class="title-nutrition">
                    {{ item.nutritional_information.name }}
                    </span>
                    <span class="description-detail font-weight-bold value-nutrition">{{ item.value }}</span>
                  </div>
                  <div class="content-information-nutrition" v-for="item in item.more_detail" :key="item.field">
                    <span class="description-detail ml-10">
                      {{ item.field }}
                    </span>
                    <span class="description-detail value-nutrition">{{ item.value }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="open_modal_category"
      width="900"
    >
      <v-card v-if="detail">
        <div class="container-detail">
          <div class="row">
            <div class="col d-flex justify-end">
              <v-btn text small @click="() => open_modal_category = !open_modal_category">
                <v-icon color="#0D3B60">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="content">
                <div class="d-flex align-items-center justify-content-between">
                  <h1 class="title-detail">{{ detail.name }}</h1>
                  <img class="img-flavor-detail" :src="detail.url_icon" :alt="detail.name">
                </div>
                <p class="description-detail" v-html="detail.description"></p>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import HomeService from '@/services/home.service'
export default {
  data: () => ({
    categories: [],
    flavors: [],
    detail: {},
    open_modal_category: false,
    open_modal_flavor: false
  }),
  methods: {
    async getDataFlavors() {
      const { data:res } = await HomeService.getDataLanding()
      if (res.success) {
        this.categories = res.categories.filter(i => i.name !== 'Extras' && i.id !== 3)
        //this.flavors = res.flavors
      }
    },
    viewDetailCategory(item) {
      this.detail = item
      this.open_modal_category = true
    },
    viewDetailFlavor(flavor) {
      if (!flavor.show_nutritional_info) return
      this.detail = flavor
      this.open_modal_flavor = true
    }
  },
  created() {
    this.getDataFlavors()
  }
}
</script>

<style scoped>
.container-detail {
  background-color: #FCEEF4 !important;
  padding: 15px
}
.flavors {
  width: 90%;
  background: #FCEEF4;
  height: auto;
  padding: 15px;
  border-radius: 20px;
  margin: auto;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}
.flavors:before, .flavors:after {
  background: none repeat scroll 0 0 rgba(0, 0, 0, 0.7);
  bottom: 15px;
  box-shadow: 0 15px 10px rgba(0, 0, 0, 0.7);
  content: "";
  left: 10px;
  max-width: 300px;
  position: absolute;
  top: 80%;
  transform: rotate(-3deg);
  width: 50%;
  z-index: -1;
}
.flavors:after {
  left: auto;
  right: 10px;
  transform: rotate(3deg);
}
.title-landing {
  font-size: 50px;
  color: #0D3B60;
  font-family: 'Backwards Light'  !important;
  margin-top: 30px;
  margin-bottom: 50px;
  line-height: 1;
  font-weight: bold
}
.frutas {
  width: 50%;
  height: 250px;
  max-height: 550px
}
.helados {
  width: 50%;
  height: 250px;
  max-height: 550px
}
.hojas {
  width: 60%;
  height: 250px;
  max-height: 450px
}
.question-flavors {
  margin-top: 50px
}
.title-with-image {
  color: #0D3B60;
  font-family: 'Backwards Light'  !important;
  margin-bottom: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.content-flavor {
  width: 100%;
  display: flex;
  justify-content: start;
  flex-shrink: 2
}
.title-with-image h2 {
  margin-top: 10px;
  cursor: pointer;
  font-size: 25px
}
.title-with-image h2:hover {
  text-decoration: underline
}
.title-with-image .title-category {
  margin-top: 20px
}
.img-categoria-sabor {
  margin-right: 20px;
}
.img-categoria-sabor1 {
  width: 25px;
  height: 50px;
  max-height: 100px
}
.img-categoria-sabor2 {
  width: 80px;
  height: 50px;
  max-height: 100px
}
.img-sabor {
  width: 40px;
  height: 40px;
  max-height: 100px;
  margin-right: 20px;
}
.content-information-nutrition {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px
}
.title-detail {
  color: #0D3B60;
  font-family: 'Backwards Light'  !important;
  font-size: 40px;
}
.description-detail {
  font-family: 'Baloo Regular';
  color: #0D3B60;
  font-size: 16px;
}
.img-flavor-detail {
  width: 90px;
  margin-bottom: 60px
}
.title-nutrition {
  font-family: 'Baloo Regular';
  color: #0D3B60;
  font-weight: bold;
  font-size: 16px;
}
@media screen and (min-width: 2501px) and (max-width: 5060px) {
  .v-dialog {
    width: 1600px !important
  }
}
</style>
